module.exports = __webpack_public_path__ + "img/arrow-right-small.046bdc28.svg";